<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :height="height || tableHeight - 3"
      :loading="loading"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      keep-source
      row-key
      size="small"
      show-footer
      :footer-method="footerMethod"
      class="sample-material-table"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="d-flex align-items-stretch">
            <div class="side-frame" v-if="buttonFlag && !disabled"></div>
            <div class="d-flex align-items-center">
              <span
                style="font-size: 14px; color: #606266"
                v-if="buttonFlag && !disabled"
              >
                {{ $l('INDEX.form_label_material_composition') || '物料构成' }}
              </span>
              <el-divider
                direction="vertical"
                v-if="buttonFlag && !disabled"
              ></el-divider>

              <b-button
                v-if="!disabled"
                size="sm"
                class="mr-2"
                variant="outline-success"
                :disabled="disabled"
                @click="openSampleMaterialDialog({ type: 'add' })"
                >{{ $l('form_label_add_material') || '新增物料' }}
              </b-button>

              <b-button
                v-if="!disabled"
                size="sm"
                class="mr-2"
                variant="outline-primary"
                :disabled="disabled"
                @click="updateFabric()"
              >
                {{ $l('btn_update_fabric') || '更新面料' }}
              </b-button>

              <b-button
                v-if="!disabled && !buttonFlag"
                size="sm"
                class="mr-2"
                variant="outline-success"
                :disabled="disabled"
                @click="synchronousPrice()"
                >{{ $l('INDEX.form_label_synchronous_price') || '同步价格' }}
              </b-button>
            </div>
          </div>
        </slot>
      </template>
      <template v-slot:opt1>
        <span class="drag-btn">
          <i class="vxe-icon--menu"></i>
        </span>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:materialNoInfo="{ row }">
        <span>{{ row.materialNo }} </span>
        <br />
        <span
          >{{ row.mainMaterialCategoryName }} /
          {{ row.detailMaterialCategoryName }}</span
        >
      </template>
      <template v-slot:materialNameInfo="{ row }">
        <span>{{ row.materialName }} </span>
        <br />
        <span>{{ row.materialNameEn }}</span>
        <br />
      </template>
      <template v-slot:displayNameInfo="{ row }">
        <span>{{ row.displayName }} </span>
        <br />
        <span>{{ row.displayNameEn }}</span>
      </template>
      <template v-slot:usageQtyInfo="{ row }">
        <span>{{ row.usageQty }} {{ row.qtyUnit }}</span>
      </template>
      <template v-slot:price="{ row }">
        <span
          >{{ row.price }} / {{ row.v_qtyUnit ? row.v_qtyUnit : '--' }}</span
        >
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="openSampleMaterialDialog({ type: 'edit', data: row })"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.sampleMaterialCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>

    <!-- 样品物料dialog -->
    <SampleMaterialDialog
      :disabled="sampleMaterialDialogOptions.disabled"
      :visible.sync="sampleMaterialDialogOptions.visible"
      :title="sampleMaterialDialogOptions.title"
      :formData.sync="sampleMaterialDialogOptions.formData"
      :productLine="productLine"
      :categoryCode="categoryCode"
      @reload="loadData()"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import Sortable from 'sortablejs'
import TableAutoHeight from '@/mixins/table-auto-height'
import SampleMaterialDialog from './components/detail/dialog.vue'
import tableColumns from './table-columns'
import { format, add } from '@/libs/util.number.js'
export default {
  components: { SampleMaterialDialog },
  mixins: [EditLoading, TableAutoHeight],
  props: {
    disabled: { type: Boolean, default: false },
    buttonFlag: { type: Boolean, default: false },
    sampleCode: { type: String, default: '' },
    proofingCode: { type: String, default: '' },
    productLine: { type: String, default: '' },
    categoryCode: { type: String, default: '' },
    height: { type: Number, default: 0 },
  },
  data() {
    return {
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.loadData(),
        },
        zoom: true,
        custom: true,
      },
      tableData: [],
      tableColumns: tableColumns(this, this.disabled),
      sampleMaterialDialogOptions: {
        disabled: false,
        visible: false,
        title: '',
        formData: {},
      },
    }
  },
  watch: {
    sampleCode: {
      handler() {
        this.loadData()
      },
      immediate: true,
    },
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const { tableData } = this.$refs.table.getTableData()
      if (!tableData) return 0
      const totalColumnValues = tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          if (!t.isTotalColumn) return ''
          const val = totalColumnValues[t.field]
          return val ? format(val) : '0'
        })
      result[0] = this.$l('INDEX.total') || '合计'
      return [result]
    },
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
    this.rowDrop()
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    loadData() {
      this.getData(this.sampleCode).then((res) => {
        this.tableData = []
        this.tableData = res
      })
    },
    async getData(sampleCode) {
      if (!sampleCode) return Promise.resolve([])

      if (this.proofingCode) {
        return await this.$api
          .proofingSampleMaterialListApi({ sampleCode })
          .then((res) => Promise.resolve(res.body.data))
      }
      return await this.$api
        .sampleInfoMaterialListApi({ sampleCode })
        .then((res) => Promise.resolve(res.body.data))
    },
    del(sampleMaterialCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.submitDel(sampleMaterialCode).then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.loadData()
        })
      })
    },
    async submitDel(sampleMaterialCode) {
      if (this.proofingCode) {
        return await this.$api.proofingSampleMaterialDelApi({
          sampleMaterialCode,
        })
      }
      return await this.$api.sampleInfoMaterialDelApi({ sampleMaterialCode })
    },
    rowDrop() {
      this.$nextTick(() => {
        const xTable = this.$refs.table
        this.sortable = Sortable.create(
          xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'),
          {
            handle: '.drag-btn',
            onEnd: ({ newIndex, oldIndex }) => {
              if (newIndex == oldIndex) return
              const tableData = [...this.tableData]
              let listMaterial = []
              if (newIndex > oldIndex) {
                for (let i = oldIndex + 1; i <= newIndex; i++) {
                  const sortOrder = tableData[i].sortOrder - 1
                  const sampleMaterialCode = tableData[i].sampleMaterialCode
                  listMaterial.push({ sortOrder, sampleMaterialCode })
                }
              } else {
                for (let i = oldIndex - 1; i >= newIndex; i--) {
                  const sortOrder = tableData[i].sortOrder + 1
                  const sampleMaterialCode = tableData[i].sampleMaterialCode
                  listMaterial.push({ sortOrder, sampleMaterialCode })
                }
              }
              listMaterial.push({
                sortOrder: tableData[newIndex].sortOrder,
                sampleMaterialCode: tableData[oldIndex].sampleMaterialCode,
              })
              this.updateSort(listMaterial)
            },
          }
        )
      })
    },
    openSampleMaterialDialog({ type, data = {} }) {
      const types = {
        add: this.$l('dialog_title_sample_material_add') || '添加物料信息',
        edit: this.$l('dialog_title_sample_material_edit') || '编辑物料信息',
        detail:
          this.$l('dialog_title_sample_material_detail') || '物料信息详情',
      }
      this.sampleMaterialDialogOptions = {
        visible: true,
        disabled: type === 'edit',
        title: types[type],
        formData: {
          ...data,
          sampleCode: this.sampleCode,
          productLine: this.productLine,
          categoryCode: this.categoryCode,
          proofingCode: this.proofingCode,
          wid: '',
          widUnit: '',
          fabricWeight: '',
          fabricWeightUnit: '',
        },
      }
    },
    updateSort(listMaterial) {
      this.submitUpdateSort(listMaterial).then((res) => {
        const { status } = res
        if (status === 200) {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_update_ok') || '修改成功！',
            type: 'success',
          })
          this.loadData()
        } else {
          this.$message.error(this.$l('INDEX.tips_update_no') || '修改失败！')
        }
      })
    },
    async submitUpdateSort(listMaterial) {
      if (this.proofingCode) {
        return await this.$api.proofingSampleMaterialUpdateSortApi({
          listMaterial,
        })
      }
      return await this.$api.sampleInfoMaterialUpdateSortApi({ listMaterial })
    },

    footerMethod() {
      // 返回一个二维数组的表尾合计
      return this.footerData
    },
    synchronousPrice() {
      let updateCostPriceApi = {}
      let costPriceData = {
        sampleCode: this.sampleCode,
      }
      if (!this.proofingCode) {
        updateCostPriceApi = this.$api.sampleInfoMaterialUpdateCostPriceApi(
          costPriceData
        )
      } else {
        updateCostPriceApi = this.$api.proofingSampleMaterialUpdateCostPriceApi(
          costPriceData
        )
      }
      updateCostPriceApi.then(() => {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
    getCheckboxRecords() {
      return this.$refs.table
        .getCheckboxRecords()
        .concat(this.$refs.table.getCheckboxReserveRecords())
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
    },
    async updateFabric() {
      const data = this.getCheckboxRecords()

      if (!data.length) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据!!',
          type: 'warning',
        })
        return
      }

      const confirm = await this.$confirm(
        `确认要更新当前选中的${data.length}条数据吗？`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const listSampleMaterialCode = data.map((item) => item.sampleMaterialCode)

      if (this.loadingOpen()) return
      const res = await this.$api
        .sampleInfoMaterialUpdateFabricApi({ listSampleMaterialCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status, msg } = res
      const error = status != 200
      this.$message({ message: msg, type: error ? 'error' : 'success' })
      if (error) return

      this.clearCheckboxRow()

      this.loadData()
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
.sample-material-table .drag-btn {
  cursor: move;
  font-size: 12px;
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
